function startCountdown(endDateStr, index) {
  // Parsowanie daty zakończenia (w formacie DD-MM-YY/HH:MM)
  if (!/^\d{2}-\d{2}-\d{2}\/\d{2}:\d{2}$/.test(endDateStr)){
    document.getElementById(`announcement-bar-display__${index}`).innerText = "";
    return;
  }
  const [datePart, timePart] = endDateStr.split('/');
  const [day, month, year] = datePart.split('-');
  const [hours, minutes] = timePart.split(':');
  
  // Tworzymy obiekt daty zakończenia
  const endDate = new Date(`20${year}`, month - 1, day, hours, minutes);

  // Funkcja odświeżająca odliczanie co sekundę
  const countdownInterval = setInterval(() => {
      const now = new Date();
      const timeRemaining = endDate - now;

      // Sprawdzamy, czy promocja się zakończyła
      if (timeRemaining <= 0) {
          clearInterval(countdownInterval);
          document.getElementById(`announcement-bar-display__${index}`).innerText = "";
          return;
      }

      // Obliczamy dni, godziny, minuty i sekundy pozostałe do końca promocji
      const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      // Wyświetlamy odliczanie
      document.querySelector(`#announcement-bar-display__${index} strong`).innerText = 
         `${addLeadingZero(days)}:${addLeadingZero(hours)}:${addLeadingZero(minutes)}:${addLeadingZero(seconds)}`;
  }, 1000);
}
function addLeadingZero(value) {
  return value.toString().padStart(2, '0');
}

document.addEventListener("DOMContentLoaded", function(){
  const promotion_dates = Array.from(document.querySelectorAll('[id^="annoucement-bar-date__"]'))
  promotion_dates.forEach(function(date){
    const value = date.value
    const index = date.id.split('__')[1]
    startCountdown(value, index)
  })
})
